import { render, staticRenderFns } from "./CustomerStatus.vue?vue&type=template&id=ab628d5c&scoped=true&"
import script from "./CustomerStatus.vue?vue&type=script&lang=js&"
export * from "./CustomerStatus.vue?vue&type=script&lang=js&"
import style0 from "./CustomerStatus.vue?vue&type=style&index=0&id=ab628d5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab628d5c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
